import { useEffect, useRef } from 'react';

import { Box } from '@mui/material';

import NoMessagesScreen from '@/features/AIChat/AskGXDrawer/components/NoMessagesScreen/NoMessagesScreen';
import { useChat } from '@/features/AIChat/context/useChat';

import MessageComponent from '../Messages';

const Chat = () => {
  const { messages } = useChat();
  const bottomRef = useRef<HTMLDivElement | null>(null);
  useEffect(() => {
    const el = bottomRef.current as unknown as {
      scrollIntoView?: (opts?: ScrollIntoViewOptions) => void;
    } | null;
    el?.scrollIntoView?.({ behavior: 'smooth' });
  }, [messages]);

  if (messages.length === 0) return <NoMessagesScreen />;

  return (
    <Box
      sx={{
        flex: 1,
        display: 'flex',
        flexDirection: 'column',
        overflowY: 'auto',
        padding: '16px'
      }}
    >
      {messages.map((msg, index) => {
        return (
          <MessageComponent
            key={msg.id}
            index={index}
            msg={msg}
          />
        );
      })}

      <div ref={bottomRef} />
    </Box>
  );
};

export default Chat;
